<template lang="pug">
  .product-actions
    //- color switcher
    .mb-10.flex.justify-center(v-if="productVariations && productVariations.length > 1")
      //- router-link.mx-10(v-for="prd in productVariations", :to="{name: 'product', params: {handle: prd.handle}}", :key="prd.handle", :aria-label="getColorTag(prd)", @)
      button.mx-5.mb-10.p-px(v-for="prd in productVariations", @click="$emit('changeColor', prd.handle)", :aria-label="`Change color to: ${getColorTag(prd)}`")
        color-swatch(:name="getColorTag(prd)", :active="prd.handle === product.handle")

    //- actions
    .relative(v-if="!buttonsHidden")
      //- ENQUIRE
      template(v-if="enquiry")
        //- enquire btn
        .flex.justify-center
          button.w-full.sm-w-auto.min-w-btn.btn-theme-black(@click="$emit('enquire')")
            btn(theme="inherit") Enquire

      //- PURCHASE
      template(v-else-if="active")
        //- main
        .flex.justify-center.transition-opacity.duration-200(:class="{'opacity-0 pointer-events-none': checkoutBtnVisible, 'delay-200': !checkoutBtnVisible}")
          //- (option selectors)
          template(v-if="variants.length > 1 || sizeOptionOnly")
            .relative.w-full.sm-w-auto.min-w-btn-md.mx-5.lg-mx-10.text-left
              //- (variant dropdown selector)
              template(v-if="variants.length > 1")
                button.h-40.flex.items-center.pl-20.pr-36.w-full.pt-3.relative.z-10.text-13.truncate.btn-theme-outlined(@click="optionsVisible = !optionsVisible", :class="{'hover-text-blue hover-border-current': !optionsVisible}")
                  template(v-if="sizeOptionOnly")
                    | Size: {{ formatOptionTitle(active.title) }}
                  template(v-else)
                    | {{ optionsVisible ? 'Select' : formatOptionTitle(active.title) }}
                  icon-chevron.absolute.right-0.h-full.top-0.flex.items-center.pr-15(:up="optionsVisible")
                ul.absolute.w-full.left-0.border.border-gray-300.py-10.-mt-px.bg-gray-100.text-13(v-show="optionsVisible")
                  //- options...
                  li(v-for="vrnt in variants")
                    button.btn-theme-text.w-full.pr-12.pl-20.py-3.text-left(:class="{'text-blue': vrnt.id === active.id}", @click="select(vrnt)", :disabled="vrnt.availableForSale === false") {{formatOptionTitle(vrnt.title)}}
              //- (single size -> disabled dropdown)
              template(v-else-if="sizeOptionOnly")
                button.btn-theme-outlined.w-full(disabled)
                  btn.w-full.truncate(theme="inherit")
                    template(v-if="sizeOptionOnly")
                      | Size: {{ formatOptionTitle(active.title) }}
                    template(v-else)
                      | {{ optionsVisible ? 'Select' : formatOptionTitle(active.title) }}
          //- (qty)
          input.input-qty.text-13.border.border-gray-300.text-center.bg-transp.w-50.hover-border-blue.focus-border-blue.pt-2(v-if="qtyEnabled", v-model="qty", type="number", min="0", size="2", @click="e => e.target.select()", @keydown.enter="e => e.target.blur()")
          //- add to bag btn
          button.w-full.sm-w-auto.min-w-btn-md.max-w-300.mx-5.lg-mx-10.btn-theme-black(@click="addToBag", :disabled="active && active.availableForSale === false")
            btn(theme="inherit") {{ active.availableForSale === false ? 'Sold Out' : 'Add to Bag' }}
        //- (checkout btn)
        transition(name="product-btns")
          .absolute.w-full.top-0.left-0.flex.justify-center.transition-opacity.duration-200(v-show="checkoutBtnVisible")
            a.min-w-btn-md.mx-5.lg-mx-10.btn-theme-black(v-if="checkout", :href="checkout.webUrl", target="_blank")
              btn(theme="inherit") Checkout

        //- fine print
        //- wp-rich-text.mt-20.text-center.text-11.md-text-13(v-if="finePrint && finePrintVisible", :html="finePrint")

    //- size guide button
    .flex.justify-center.mt-20.text-11.md-text-13
      button.inline-block.mx-10.btn-theme-text.border-b.border-gray-300.focus-border-current(v-if="detailsLink", @click="$emit('viewSizing')") Details & Sizing
      button.inline-block.mx-10.btn-theme-text.border-b.border-gray-300.focus-border-current(v-if="shippingLink", @click="$emit('viewShipping')") Shipping & Returns
</template>

<script>
import { mapState } from 'vuex'
import { variantId as vId } from '@/utils'
import IconChevron from '@/components/Icons/ChevronY'
import ColorSwatch from './ColorSwatch'
export default {
  name: 'ProductActions',
  // props: ['product', 'active', 'enquiry', 'finePrintVisible'],
  props: {
    product: { type: Object, default: undefined },
    active: { type: Object, default: undefined }, // variant
    enquiry: { type: Object, default: undefined },
    // finePrintVisible: { type: Boolean, default: true },
    initialProductVariations: { type: Array, default: undefined },
    detailsLink: { type: Boolean, default: true },
    shippingLink: { type: Boolean, default: true },
    buttonsHidden: { type: Boolean, default: false }
  },
  data () {
    return {
      optionsVisible: false,
      checkoutBtnVisible: false,
      enquire: false,
      qty: 1,
      productVariations: null // colors as separate products with same title
    }
  },
  computed: {
    ...mapState({
      checkout: state => state.shop.checkout
      // finePrint: state => state.site && state.site.hostem_product_fine_print
    }),
    variants () {
      return this.product ? this.product.variants.edges.map(itm => itm.node) : []
    },
    colorOption () {
      return this.product && this.product.options.find(opt => opt.name.toLowerCase().startsWith('colo'))
    },
    sizeOptionOnly () {
      const nonColor = !this.product ? [] : this.product.options.filter(opt => !opt.name.toLowerCase().startsWith('colo'))
      const hasSize = nonColor.filter(opt => opt.name.toLowerCase() === 'size').length
      return hasSize && nonColor.length === 1
    },
    qtyEnabled () {
      return this.product && this.product.metafields && this.product.metafields.edges.find(edge => edge.node.key === 'quantity_input_enabled')
    }
  },
  methods: {
    addToBag () {
      const qty = Math.max(1, Number(this.qty))
      this.$store.dispatch('shop/addItemToCheckout', { variantId: this.active.id, quantity: qty })
        .then(() => {
          // flash checkout btn
          this.checkoutBtnVisible = true
          setTimeout(() => { this.checkoutBtnVisible = false }, 3000)
        })
    },
    select (vrnt) {
      this.$emit('variant', vrnt)
      this.optionsVisible = false
    },
    formatOptionTitle (ttl) {
      // omitt color if mono-color
      if (!this.colorOption || this.colorOption.values.length > 1) return ttl
      const val = this.colorOption.values // single value
      return ttl.replace(`${val} / `, '')
    },
    setDefaultVariant () {
      let vrnt = this.variants.find(vrnt => vId(vrnt.id) === this.$route.query.variant)
      vrnt = vrnt || this.variants.find(v => v.availableForSale)
      this.$emit('variant', vrnt)
    },
    async getProductVariations (doc) {
      /*
       * Find products with matching title,
       * representing variations (usually color) of a product
      */
      // skip if already set (ProductThumbFull.vue)
      if (this.initialProductVariations) {
        this.productVariations = this.initialProductVariations
      }
      if (!doc) return false
      try {
        // TODO - consider searching by handle base: brand-name-shoe-green >> brand-name-shoe
        // drawback is handle is a bit hidden in Shopify...
        // let handleBase = this.doc.handle.substring(0, this.doc.handle.lastIndexOf('-'))
        const resp = await this.$store.dispatch('shop/getProducts', { query: doc.title })
        const prds = (resp && resp.edges && resp.edges.map(edge => edge.node)) || []
        this.productVariations = prds.filter(prd => prd.title === doc.title) // EXACT TITLE MATCH !!
        this.$emit('foundVariations', this.productVariations)
      } catch (e) {
        console.error(e)
      }
    },
    getColorTag (prdct) {
      return prdct.tags.find(tag => tag.toLowerCase().startsWith('colour:')) || {}
    }
  },
  created () {
    this.setDefaultVariant()
    this.getProductVariations(this.product)
  },
  components: { ColorSwatch, IconChevron }
}
</script>

<style>
.product-btns-enter-active{ transition: opacity 200ms 200ms; }
.product-btns-leave-active{ transition: opacity 0ms 200ms; }
.product-btns-enter,.product-btns-leave-to{ opacity:0; }
</style>
